import React from 'react';
import { Link } from "react-router-dom";
import createLink from "../../libs/createLink";
import logo from "../../images/logo-white.png";

const Footer = () =>{
    return (
        <div id="footer">
            <img src={logo} alt={""} className={"logo"} />
            <div className="wrapper-footer">
                <ul>
                    <li><Link to={createLink("parentalControl")}>Contrôle parental</Link></li>
                    <li><Link to={createLink("trustSecurity")}>Confiance et sécurité</Link></li>
                    <li><Link to={createLink("charter")}>Charte</Link></li>
                    <li><Link to={createLink("cgus")}>Mentions légales</Link></li>
                    <li><Link to={createLink("contact")}>Contact</Link></li>
                </ul>
            </div>

        </div>
    )
}
export default Footer;